import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';

import CategoriesShowCard from '../../Components/CategoriesShowCard/CategoriesShowCard';
import Loading from '../../Components/Loading/Loading';
import PlayerShowCard from '../../Components/PlayerShowCard/PlayerShowCard';
import Categories from './Components/Categories';
import Featured from './Components/Featured';
import Live from './Components/Live';
import * as service from "./service";
import useScrollPosition from '../../Components/ScrollPosition/useScrollPosition';
import Genres from './Components/Genres';
import LiveChannels2 from '../LiveChannels/LiveChannels2';
const Homepage = () => {
  const projectInfo=useSelector((state)=>state?.projectInfo?.value);
  const accessToken=useSelector((state)=>state?.accessToken?.value);
  const thumbnailOrientation = projectInfo?.projectConfig?.config?.THUMBNAIL_ORIENTATION;

  const [loading ,setLoading] = useState(true)
  const [homeData,setHomeData] = useState([])
  const [homeDataSliceCount, setHomeDataSliceCount] = useState(8);

  const location = useLocation();
  const params = useParams();
  const keyFromRoute = location?.state?.key || params?.key;
  
  const homePageContainerRef = useRef()
  const scrollPosition = useScrollPosition();

  const appInfo={
    projectDetails:projectInfo,
    accessToken:accessToken
  }
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [keyFromRoute]);

  useEffect(()=>{
    if(!loading && homeDataSliceCount<homeData?.length){
      lazyLoad()
    }
  },[loading,scrollPosition,homeData])
  useEffect(()=>{
    window.scroll(0,0)
   setLoading(true)
    fetchShowDetails(keyFromRoute);

  },[keyFromRoute])

  
  
  const fetchShowDetails = async(key)=>{
    try{
      const response = await  service.getShowsByCategory(appInfo, key);
      if(response?.status === 200){
        setHomeData(response?.data?.data)
        setLoading(false)
      }
    }
    catch{
      setLoading(true)
    }
  }

  const lazyLoad = () => {
    const containerHeight = homePageContainerRef?.current?.clientHeight;
    if(scrollPosition + 2500 >= containerHeight){
      setHomeDataSliceCount(homeDataSliceCount+5)
    }
  }

if(loading){
  return(
    <Loading/>
  )
}

  return (
    <div className='homePage' ref={homePageContainerRef}>
        {
          homeData?.slice(0,homeDataSliceCount)?.map((item,index) => {
            
            if(item?.type==="FEATURED") {
              return <Featured key={index} data={item} />
            }
            else if(item?.banner) {
              return <CategoriesShowCard key={index} data={item} />
            }
            else if(item?.type === "LIVE"){
              // return <Live data={item}/>
              return <LiveChannels2 key={"livechannels-homepage"} hideEpg={true} channelId={item?.shows?.[0]?.channel_id} />
            }
            else if(item?.type === "GENRES") {
              return <Genres key={index} data={item} />
            }
             else if(item?.type!=="LIVE"){
              return <Categories key={index} data={item} type={item?.type} />
            }else{
              return null
            }
})
        }
    </div>
  )
}

export default Homepage
